export default __webpack_public_path__ + "static/media/ISSO SYLLABUS 2027-26 CLASS 4.342ba6d4.pdf";